// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"127efce4","175":"b6c02a92","377":"05adedc1","436":"427017af","787":"627756db"}[chunkId] + ".chunk.js";
};